mutation InvoiceSigningRowProtection(
  $input: InvoiceSigningRowProtectionInput!
) {
  invoiceSigningRowProtection(input: $input) {
    secureRowLevel {
      id
      name
    }
  }
}
